import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div id=\"standby-ready\" hidden></div>\n",{ moduleName: "@cardstack/host/templates/standby.hbs" })